import { useEffect } from 'react';

export interface UseEffectProps {
  effect: () => void;
  deps: any[];
}

export const UseEffect = ({ effect, deps }: UseEffectProps) => {
  useEffect(effect, deps);
  return null;
};
